<template>
  <div>
    <title-edit header="About" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Branch* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Order :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.orders" @update="updateOrders" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Name TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.name_th" @update="updateNameTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Name EN* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.name_en" @update="updateNameEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.description_th" @update="updateDescriptionTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.description_en" @update="updateDescriptionEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Full profile TH :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.full_profile_th" @update="updateFullProfileTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Full profile EN :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.full_profile_en" @update="updateFullProfileEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Image name :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.image_name" @update="updateImageName" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Image path* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.image_path" @update="updateImagePath" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Video url* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.video_url" @update="updateVideoUrl" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Template for site* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <select-option :items="templates" :model="form.template" @update="updateTemplate" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Slide Image :</label>
      </v-col>
      <v-col cols="6" sm="8">
        <v-row>
          <v-col v-for="(image, index) in form.slide_images" :key="index" cols="4">
            <v-card @click="removeSlideImage(index)">
              <v-img
                :src="image.slide_images_show"
                title="click for remove image"
                width="150px"
                height="150px"
              />
            </v-card>
          </v-col>
        </v-row>
        <input-image-upload
          id="image"
          menu="about"
          :branch_id="form.branch_id"
          @update="updateSlideImage"
          width="140px"
          height="140px"
        />
      </v-col>
    </div>
    <line-hr />
    <div class="row text-right">
      <v-spacer></v-spacer>
      <delete-button @click.native="deleteAbout" />
      <preview-button />
      <save-button @click.native="saveAbout" />
    </div>
<!--        <pre>{{form}}</pre>-->
  </div>
</template>

<script>
import SaveButton from "../../components/Button/SaveButton";
import PreviewButton from "../../components/Button/PreviewButton";
import DeleteButton from "../../components/Button/DeleteButton";
import LineHr from "../../components/Icon/line-hr";
import TitleEdit from "../../components/TitleHeader/TitleEdit";
import InputTextField from "../../components/Input/InputTextField";
import SelectOption from "../../components/Input/selectOption";
import InputEditor from "../../components/Input/InputEditor";
import InputTextArea from "../../components/Input/InputTextArea";
import InputImageUpload from "../../components/Input/InputImageUpload";
import { mapState } from "vuex";
export default {
  name: "AboutEdit",
  components: {
    InputImageUpload,
    InputTextArea,
    InputEditor,
    SelectOption,
    InputTextField,
    TitleEdit,
    LineHr,
    DeleteButton,
    PreviewButton,
    SaveButton
  },
  data() {
    return {
      optionBranch: [],
      templates: [
        { value: null, text: "template about for tcdc site " },
        { value: 1, text: "TCDC BANGKOK " },
        { value: 2, text: "COMMONS - TCDC CHIANGMAI - TCDC KHONKEAN" },
        { value: 3, text: "MINI TCDC" }
      ]
    };
  },
  computed: {
    ...mapState({
      form: state => {
        return state.About.form;
      }
    })
  },
  created() {
    this.getBranchData();
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    validateSave() {
      if (!this.form.branch_id) {
        alert("please select Branch !");
        return false;
      } else if (!this.form.name_th) {
        alert("please insert Name TH !");
        return false;
      } else if (!this.form.name_en) {
        alert("please insert Name EN !");
        return false;
      } else if (!this.form.description_th) {
        alert("please insert Description TH !");
        return false;
      } else if (!this.form.description_en) {
        alert("please insert Description EN !");
        return false;
      } else if (!this.form.image_path) {
        alert("please insert Image path !");
        return false;
      } else {
        return true;
      }
    },
    saveAbout() {
      this.$store
        .dispatch("About/saveAbout", {
          id: this.form.id,
          data: this.form
        })
        .then(res => {
          alert(res.response_msg);
          if (res.response_code == 200) {
            this.goToAboutTable();
          }
        })
        .catch(() => {
          alert("cannot save about data");
        });
    },
    deleteAbout() {
      this.$store
        .dispatch("About/deleteAbout", this.form.id)
        .then(res => {
          alert(res.response_msg);
          if (res.response_code == 200) {
            this.goToAboutTable();
          }
        })
        .catch(() => {
          alert("cannot delete about data");
        });
    },
    goToAboutTable() {
      this.$router.push("/about/about");
    },
    updateOrders(val) {
      this.form.orders = val;
    },
    updateBranch(val) {
      this.form.branch_id = val;
    },
    updateTemplate(val) {
      this.form.template = val;
    },
    updateNameTH(val) {
      this.form.name_th = val;
    },
    updateNameEN(val) {
      this.form.name_en = val;
    },
    updateDescriptionEN(val) {
      this.form.description_en = val;
    },
    updateDescriptionTH(val) {
      this.form.description_th = val;
    },
    updateFullProfileTH(val) {
      this.form.full_profile_th = val;
    },
    updateFullProfileEN(val) {
      this.form.full_profile_en = val;
    },
    updateImagePath(val) {
      this.form.image_path = val;
    },
    updateVideoUrl(val) {
      this.form.video_url = val;
    },
    updateImageName(val) {
      this.form.image_name = val;
    },
    updateSlideImage(val) {
      let slide_images_show = val.fullImagePath;
      let slide_images = val.imagePath;
      let data = {
        slide_images_show,
        slide_images
      };
      this.$store.dispatch("About/insertSlideImage", data);
    },
    removeSlideImage(index) {
      this.$store.dispatch("About/removeSlideImage", index);
    },
    updateContactEmail(val) {
      this.form.contact_email = val;
    },
    updateContactInfo(val) {
      this.form.contact_info = val;
    },
    updateViewer(val) {
      this.form.viewer = val;
    },
    updateSlugURL(val) {
      this.form.slug_url = val;
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/switch.css";
</style>
